import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Grid, Header, Image } from 'semantic-ui-react';
import back from '../../assets/svg/back_arrow.svg';
import ConfirmCloseModal from '../../components/Modal/ConfirmDeleteModal';
import { setFormOpen } from '../../views/main/actions/sidebarActions';

interface Props {
  title: string | JSX.Element;
  color?: string;
  marginTop?: string;
  backButton?: JSX.Element;
  subtitle?: string;
  headerItems?: JSX.Element;
  leftItems?: JSX.Element;
  rightItemsFirst?: JSX.Element;
  rightItemsSecond?: JSX.Element;
  id?: string
  backTitle?: string
  backLocation?: string
  column?: boolean
  subTitleFont?: string
  subTitleBold?: boolean
  subTitleMT?: string
  subPadding?: string
  formDirty?: boolean
  onBackClick?: () => void
  setFormDirty?: (dirty: boolean) => void
  setFormOpen?: (open: boolean) => void
  setOpenConfirmModal?: (open: boolean) => void
}

export const ContentHeader = (props: Props): JSX.Element => {
  const {
    title, color, marginTop, subtitle,
    subTitleFont, subTitleBold, subPadding,
    subTitleMT, headerItems, leftItems, rightItemsFirst,
    rightItemsSecond, id, backTitle,
    backLocation, backButton, column,
    onBackClick, formDirty, setFormDirty, setOpenConfirmModal
  } = props

  const _location = useLocation()
  const _history = useHistory()
  const [subRoutes, setSubRoutes] = useState<string[]>([])
  const [renderModal, setRenderModal] = useState(false)
  

  useEffect(() => {
    const _locArr = _location.pathname.split('/')
    let subRoutes: string[] = []
    if (_locArr.length === 5 && (_locArr.includes('accounting')
      || _locArr.includes('budget')
      || _locArr.includes('insights')
      || _locArr.includes('settings'))) {
      subRoutes.push(_locArr[_locArr.length - 1])
    }
    if (_locArr.length === 6 && _locArr.includes('insights')) {
      subRoutes = [_locArr[_locArr.length - 2], _locArr[_locArr.length - 1]]
    }
    if (_locArr.length === 3 && _locArr.includes('reports')) {
      subRoutes = [_locArr[_locArr.length - 1]]
    }
    setSubRoutes(subRoutes)
  }, [_location.pathname])



  const handleGoBack = () => {
    if (formDirty) {
      setRenderModal(true)
    } else {
      if (backLocation) {
        if (onBackClick) {
          onBackClick()
        } else {
          const _locArr = _location.pathname.split('/')
          if (backLocation === _location.pathname) {
            _history.replace(backLocation.split('/').filter(path => path !== '')[0].replace(/^/, '/'))
          } else if (_locArr.length === 6 && _locArr.includes('insights')) {
            _history.replace(`/projects/${_locArr[2]}/insights/${_locArr[_locArr.length - 2]}`)
          } else {
            _history.replace(backLocation)
          }
        }
      }
    }
  }

  const handleBreadCrumbClick = (path: { key: string, value: string }) => {
    const splitPath = _location.pathname.split('/')
    let backStep = ''
    for (let index = 0; index < splitPath.length; index++) {
      const backSlash = index === 0 ? '' : '/'
      backStep += `${backSlash}${splitPath[index]}`
      if (splitPath[index] === path.key) {
        break
      }
    }

    _history.replace(backStep)
  }

  const subRouteNav = () => {
    const mappedSubRoutes = subRoutes.map(subRoute => {
      let _subRoute = { key: '', value: '' }
      if (subRoute.includes('-')) {
        const _splitRoute = subRoute.split('-')
        _subRoute = {
          key: subRoute,
          value: _splitRoute.map(r => {
            let str = r.substring(0, 1).toUpperCase() + r.substring(1, r.length)
            if (str === 'Fte') {
              str = 'FTE'
            }
            return str
          }).join(' ')
        }
      } else {
        _subRoute = {
          key: subRoute,
          value: subRoute.substring(0, 1).toUpperCase() + subRoute.substring(1, subRoute.length)
        }
      }
      return _subRoute
    })

    return mappedSubRoutes.map((_subRoute, idx) => {
      return (
        <div key={`${_subRoute}-${idx}`} style={{ display: 'flex', alignItems: 'center' }}>
          <Header.Subheader style={{ marginLeft: '.5rem', color: '#08D6A1' }}>/</Header.Subheader>
          <Header.Subheader onClick={() => handleBreadCrumbClick(_subRoute)} style={{ marginLeft: '.5rem', color: '#08D6A1' }}>{_subRoute.value}</Header.Subheader>
        </div>
      )
    })
  }

  const _backButton = () => {
    const isReports = _location.pathname.includes('reports')
    if (backTitle && !backButton) {
      return (
        <Grid.Row style={{ fontSize: isReports ? '2.2rem' : '1.7rem', fontWeight: isReports ? 600 : '' ,cursor: 'pointer', color: '#172533', letterSpacing: '.25px', display: 'flex', alignItems: 'center' }}>
          <div style={{ display: 'flex', alignItems: 'center', marginTop: marginTop }} onClick={handleGoBack}>
            <Image src={back} style={{ width: '13px', height: '10px' }} />
            <Header.Subheader style={{ marginLeft: '.5rem' }}>{backTitle}</Header.Subheader>
          </div>
          {subRoutes.length > 0 ? subRouteNav() : null}
        </Grid.Row>
      )
    }

    if (backButton) {
      return backButton
    }

    return null
  }

  const confirmClose = (action: 'cancel' | 'delete') => {
    if (action === 'delete') {
      if (setFormDirty) {
        setFormDirty(false)
      }
      if (setFormOpen) {
        setFormOpen(false)
      }
      if (backLocation) {
        if (onBackClick) {
          onBackClick()
        } else {
          const _locArr = _location.pathname.split('/')
          if (backLocation === _location.pathname) {
            _history.replace(backLocation.split('/').filter(path => path !== '')[0].replace(/^/, '/'))
          } else if (_locArr.length === 6 && _locArr.includes('insights')) {
            _history.replace(`/projects/${_locArr[2]}/insights/${_locArr[_locArr.length - 2]}`)
          } else {
            _history.replace(backLocation)
          }
        }
      }
    }
    if (setOpenConfirmModal) {
      setOpenConfirmModal(false)
    }
    setRenderModal(false)
  }

  return (
    <Grid id={id} columns={_location.pathname.includes('insights') ? 1 : 2} style={{ margin: '0rem', position: 'relative', zIndex: 10 }}>
      <Grid.Row stretched style={{ padding: subPadding ? subPadding : '0', justifyContent: 'space-between' }}>
        <Grid.Column style={{ alignItems: 'start', padding: 0, paddingBottom: (_location.pathname.includes('budget') && !_location.pathname.includes('insights')) || _location.pathname.includes('expenditures') ? '9px' :  0}}>
          {_backButton()}
          <Header>
            <Header.Content style={{ textAlign: 'start', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', color: color, fontSize: '31.5px', letterSpacing: '.25px', marginTop: marginTop }}>
              {title}
              <Header.Subheader style={{ marginRight: '6.3rem', marginTop: subTitleMT ? subTitleMT : '', fontSize: subTitleFont ? subTitleFont : '1.446rem', fontWeight: subTitleBold ? 'bold' : 'normal', letterSpacing: '.25px', color: '#172533' }}>{subtitle}</Header.Subheader>
            </Header.Content>
            {headerItems}
          </Header>
          {leftItems}
        </Grid.Column>
        <Grid.Column style={{ alignItems: 'flex-end', paddingRight: 0, width: 'max-content' }}>
          <div style={{ display: 'flex', alignItems: 'flex-end', flexDirection: column ? 'column' : 'row' }}>
            {rightItemsFirst}
            {rightItemsSecond}
          </div>
        </Grid.Column>
      </Grid.Row>
      <ConfirmCloseModal open={renderModal} closeModal={true} userInput={confirmClose} />
    </Grid>
  )
}
